<template>
  <filter-field label='Device'
                name='device_id'
                styles='width: 140px'
                placeholder='-- device -- '
                :optionStyles=" $vuetify.breakpoint.mdAndUp ? '': 'width:250px'"
                type='select'
                :list='devices'
                :display='display'
  />
</template>

<script>
  export default {
    name: 'filterFieldDevices',
    props: {
      display: Boolean
    },
    computed: {
      devices() {
        const arr = _.filter(this.$store.state.devices, (item) => (item.is_kiosk || item.is_clerk) && item.info)
        return _.orderBy(arr, 'info')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/filter/filterFieldDevices.vue